module.exports = __webpack_public_path__ + "static/media/work_the_network.33c70cae.svg";